/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { createCustomFieldDataLocationSchema } from './CreateCustomFieldDataLocationSchema'
import { createCustomFieldDataTypeSchema } from './CreateCustomFieldDataTypeSchema'

export const createCustomFieldDataSchema = z.object({
	name: z.string(),
	type: createCustomFieldDataTypeSchema,
	location: createCustomFieldDataLocationSchema,
	isRequired: z.boolean(),
})

export type CreateCustomFieldDataSchema = z.infer<typeof createCustomFieldDataSchema>
